import { tryCatchHelper } from '../../helpers';
import {
  ACTIVO_PERMISOS,
  ALL_PERMISOS,
  LOADING_ALL_PERMISOS,
} from './PermisosReducer';
import {
  allPermisosService,
  deletePermisosService,
  onePermisosService,
  savePermisosService,
} from './PermisosService';

export const allPermisosAction = async (
  { dispatch, isLogin = false },
  params,
) => {
  try {
    dispatch({ type: LOADING_ALL_PERMISOS, payload: true });
    const res = await allPermisosService(params);
    if (!isLogin) {
      dispatch({ type: ALL_PERMISOS, payload: res.data });
    }
    dispatch({ type: LOADING_ALL_PERMISOS, payload: false });
    return res.data.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_PERMISOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const savePermisosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await savePermisosService(id, data);
    notify(res.data.message);
    await allPermisosAction({ dispatch }, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoPermisosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_PERMISOS, payload: data });
};

export const onePermisosAction = async (dispatch, id) => {
  try {
    const res = await onePermisosService(id);
    await setActivoPermisosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deletePermisosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deletePermisosService(id);
    notify(res.data.message);
    await setActivoPermisosAction(dispatch, null);
    await allPermisosAction({ dispatch }, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
